var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { HDSRichList, HDSRichListItem, } from "@here/hds-react-components/RichList";
import { HDSTextarea } from "@here/hds-react-components/Textarea";
import { HDSDropzone } from "@here/hds-react-components/Dropzone";
import { useState } from "react";
import translations from "../../../../translations/resources/en-GB.json";
import "./style.scss";
import { defaultDropzoneStyles } from "./constants";
import indoorHelper from "../../../../store/helpers/indoorHelper";
import { ACCEPTABLE_FILE_EXTENSION } from "../../../../store/common/constants";
export var DropzoneBody = function (props) {
    var files = props.files, setFiles = props.setFiles, error = props.error, setError = props.setError, onDropZoneDesChange = props.onDropZoneDesChange, descriptionPlaceholder = props.descriptionPlaceholder, storedDescription = props.storedDescription;
    var _a = useState(false), resetd = _a[0], setResetd = _a[1];
    var _b = useState(""), description = _b[0], setDescription = _b[1];
    //const [errorStatusText, setErrorStatusText] = useState(null);
    var handleDescriptionChange = function (e) {
        var inputVal = e.detail.value;
        setDescription(inputVal);
        onDropZoneDesChange && onDropZoneDesChange(inputVal);
    };
    /**
     * will add the selected files
     */
    var addFile = function (e) {
        {
            var fileDetail = __spreadArray([], e.files, true).filter(function (_a) {
                var name = _a.name;
                return !files.some(function (e) { return e.name === name; });
            });
            setFiles(__spreadArray(__spreadArray([], files, true), fileDetail, true));
            var invalidFiles = __spreadArray(__spreadArray([], files, true), fileDetail, true).filter(function (file) { return !indoorHelper.isFileValid(file); });
            invalidFiles.length !== 0 ? setError(true) : setError(false);
        }
    };
    /**
     * will remove the selected file from the displayed list of files
     */
    var removeFile = function (e) {
        var result = files.filter(function (f) { return f !== e.file; });
        setFiles(result);
        var invalidFiles = __spreadArray([], result, true).filter(function (s) { return !indoorHelper.isFileValid(s); });
        invalidFiles.length !== 0 ? setError(true) : setError(false);
    };
    var handleDropZoneChange = function (e) {
        e.files.length > 0 && addFile(e);
        setResetd(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(HDSDropzone, { id: "dropzone-list-example", "data-testid": "dropzone", multiple: true, reset: resetd, onChange: handleDropZoneChange, error: error, textAssistive: translations.data["venonboard.dropzone.textAssistive"], textError: translations.data["venonboard.dropzone.textError"], accept: ACCEPTABLE_FILE_EXTENSION }), _jsx("div", __assign({ className: "fileListingContainer" }, { children: _jsx(HDSRichList, __assign({ className: "fileListing", "data-testid": "fileList", onAction: function (e) {
                        removeFile(e);
                        setResetd(true);
                    } }, { children: files.map(function (file, index) { return (_jsx(HDSRichListItem, { "data-testid": "fileListItem", variant: "default", headline: file === null || file === void 0 ? void 0 : file.name, subTitle: file === null || file === void 0 ? void 0 : file.size.toString(), state: indoorHelper.isFileValid(file) ? "default" : "error", errorText: "Wrong file format", file: file, hideCancel: false, hideDelete: true, hideRetry: true }, index + (file === null || file === void 0 ? void 0 : file.name))); }) })) })), _jsx("div", __assign({ style: { paddingBottom: "25px" } }, { children: _jsx(HDSTextarea, { label: "Description", placeholder: descriptionPlaceholder ||
                        translations.data["venonboard.annotationSubmit.descriptionBoxplaceholder"], rows: 4, id: "indoorMapDescription", "data-test": "indoor-map-description", "data-cy": "indoor-map-description", required: false, secondaryLabel: "Optional", value: description || storedDescription, onChange: handleDescriptionChange, style: __assign({}, defaultDropzoneStyles) }) }))] }));
};
